import { FIELD_TYPE } from '@/constants'


const categories = [
  { name: 'identityProof', base: {} }
]

export function generateDocumentField(categoryName) {
  return {
    vHtmlLabel() {
      const config = this.getSupportDocCategoryConfig(categoryName)
      return config && config.label
    },
    vHtmlDescription() {
      const config = this.getSupportDocCategoryConfig(categoryName)
      return config && config.description
    },
    category: categoryName,
    apiKey: `supportingDocuments.${categoryName}.includeFiles`,
    fields: [
      {
        apiKey: `supportingDocuments.${categoryName}.files`,
        label: 'Upload File(s)',
        required(application) {
          return true;
        },
        accept() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.supportedMIMETypes
        },
        category: categoryName,
        sizeLimitMB() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.sizeLimitMB
        },
        fileLimit() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.fileLimit
        },
        vHtmlDescription() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return (
            config &&
            config.helpText &&
            `<span class="grey--text text--lighten-2">${config.helpText}<span>`
          )
        },
        placeholder: 'Attach files',
        type: FIELD_TYPE.DOCUMENTS
      }
    ]
  }
}

export default [
  {
    label: 'Proof of Identity',
    vHtmlDescription:
      '<p>Here is the Identity documentation required for all clients.</p>',     
    type: FIELD_TYPE.HEADING
  },
  {
    type: FIELD_TYPE.PANELS,
    panels: categories.map(category => ({
      ...category.base,
      ...generateDocumentField(category.name)
    }))
  }
]
